import * as React from "react";
import JobType from "../../../../model/job/JobType";
import EditJobTypeForm from "../form/edit/EditJobTypeForm";
import Modal from "../../../ui/modal/Modal";

interface IComponentProps {
	/**
	 * On close button click.
	 */
	onClose: () => void;
	/**
	 * Job type to edit
	 */
	editedJobType: JobType;
}

export default class EditJobTypeModal extends React.Component<IComponentProps, {}> {
	render() {
		return (
			<Modal autoWidth onCloseClicked={this.props.onClose} title={"Edit Job Type"}>
				<EditJobTypeForm onClose={this.props.onClose}
								 editedJobType={this.props.editedJobType}/>
			</Modal>
		);
	}
}
